export const sortObjectsDescending = <T extends object>(items: T[], key: keyof T): T[] => {
	if (!items.length) return items;

	return items?.sort((a, b) => {
		const nameA = a[key]?.toString() ?? "";
		const nameB = b[key]?.toString() ?? "";
		return nameB.localeCompare(nameA);
	});
};

export const sortObjectsAscending = <T extends object>(items: T[], key: keyof T): T[] => {
	if (!items.length) return items;

	return items?.sort((a, b) => {
		const nameA = a[key]?.toString() ?? "";
		const nameB = b[key]?.toString() ?? "";
		return nameA.localeCompare(nameB);
	});
};

export const aliasSort = <T extends { alias: string }>(a: T, b: T): number => {
	return a.alias.localeCompare(b.alias);
};
